<template>
	<v-container fluid class="registro-page pt-4 pb-8">
	  <v-row justify="center">
	  	<v-col cols="12" md="10" lg="7">
        <v-card
          class="registro-teaser-card mb-5"
          flat
          rounded="xl"
          role="region"
          aria-labelledby="registro-teaser-title"
        >
          <div class="registro-teaser-inner">
            <div class="registro-teaser-icon-wrap" aria-hidden="true">
              <v-icon color="primary" size="36">mdi-account-plus-outline</v-icon>
            </div>
            <div class="registro-teaser-copy">
              <span class="text-overline letter-spacing-1 registro-teaser-overline">Bienvenido</span>
              <h1 id="registro-teaser-title" class="text-h6 font-weight-bold mb-2 primary--text">
                Completa tu registro
              </h1>
              <p class="text-body-2 registro-teaser-desc mb-0">
                Aún no tienes un registro completo en la plataforma. Solo te tomará unos minutos: datos personales, dirección.
              </p>
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" md="10" lg="7">
      	<v-card class="registro-wizard-card mx-auto" flat rounded="xl">
          <div class="registro-card-body">
			    <v-card-text v-if="step < 4" class="pt-5 pb-2 px-4">
			      <div class="d-flex justify-space-between align-center mb-4 flex-wrap" style="gap: 8px;">
			        <div class="d-flex align-center registro-title-wrap">
			          <v-icon color="primary" class="mr-2 flex-shrink-0">{{ iconoPaso }}</v-icon>
			          <span class="text-h6 font-weight-bold registro-main-title">{{ currentTitle }}</span>
			        </div>
			        <span class="registro-step-pill flex-shrink-0">{{ step }} de {{ totalPasosRegistro }}</span>
			      </div>

			      <v-alert
			        dense
			        text
			        color="primary"
			        border="left"
			        colored-border
			        class="mb-5 registro-intro-alert"
			      >
			        {{ textoIntroPaso }}
			      </v-alert>

			      <div class="registro-seccion-header mb-5">
			        <h2 class="registro-titulo-seccion text-uppercase primary--text mb-1">{{ seccionTitulo }}</h2>
			        <p class="registro-subtitulo-seccion mb-0">{{ seccionSubtitulo }}</p>
			      </div>
			    </v-card-text>

			    <v-window v-model="step">
			      <v-window-item :value="1">
			        <div class="px-4 pb-4">
			          <div class="registro-field-card pa-4 rounded-xl">
			          <v-form
							    ref="form"
							    v-model="valid"
							    lazy-validation
							  >
							  	<v-row>
							  		<v-col cols="12" class="pb-0">
									    <v-text-field
									      v-model.trim="usuario.nombre"
									      :rules="[rules.required]"
									      label="Nombre *"
									      required
									      rounded
									      outlined
									      hide-details="auto"
									      color="primary"
									    ></v-text-field>
							  		</v-col>

							  		<v-col cols="12" class="pb-0">
									    <v-text-field
									      v-model.trim="usuario.apellido_paterno"
									      :rules="[rules.required]"
									      label="Apellido paterno *"
									      required
									      rounded
									      outlined
									      hide-details="auto"
									      color="primary"
									    ></v-text-field>
										</v-col>

										<v-col cols="12" class="pb-0">
									    <v-text-field
									      v-model.trim="usuario.apellido_materno"
									      label="Apellido materno"
									      rounded
									      outlined
									      hide-details="auto"
									      color="primary"
									    ></v-text-field>
										</v-col>

										<v-col cols="12" class="pb-0">
									    <v-text-field
									      v-model.trim="usuario.email"
									      :rules="[rules.required, rules.email]"
									      type="email"
									      label="Correo *"
									      required
									      rounded
									      outlined
									      hide-details="auto"
									      color="primary"
									    ></v-text-field>
							  		</v-col>

										<v-col cols="6" class="pb-0">
									    <v-text-field
									      v-model.trim="usuario.edad"
									      :rules="[rules.edad]"
									      type="number"
									      min="10"
									      max="120"
									      label="Edad *"
									      hint="Número entre 10 y 120 años"
									      persistent-hint
									      required
									      rounded
									      outlined
									      hide-details="auto"
									      color="primary"
									    ></v-text-field>
										</v-col>

										<v-col cols="6" class="pb-0">
											<v-select
									    	:items="[{id:0,text:'Hombre'}, {id:1,text:'Mujer'}]"
									      v-model="usuario.sexo"
									      :rules="[rules.sexo]"
									      label="Sexo *"
									      item-text="text"
									      item-value="id"
									      hint="Requerido para completar tu perfil"
									      persistent-hint
									      rounded
									      outlined
									      hide-details="auto"
									      color="primary"
									    ></v-select>
										</v-col>

										<v-col cols="6" class="pb-0">
											<v-text-field
									      v-model="usuario.telefono"
									      :rules="[rules.telefono]"
									      type="tel"
									      label="Teléfono *"
									      hint="Solo números, mínimo 10 dígitos (ej. LADA + número)"
									      persistent-hint
									      required
									      rounded
									      outlined
									      hide-details="auto"
									      color="primary"
									    ></v-text-field>
										</v-col>

										<v-col cols="6" class="pb-0">
											<v-text-field
									      v-model="usuario.celular"
									      :rules="[rules.telefono]"
									      type="tel"
									      label="WhatsApp *"
									      hint="Mismo formato que teléfono (10 a 15 dígitos)"
									      persistent-hint
									      required
									      rounded
									      outlined
									      hide-details="auto"
									      color="primary"
									    ></v-text-field>
										</v-col>

										<v-col cols="12" class="pb-0">
											<v-text-field
									      v-model.trim="usuario.contacto_emergencia"
									      :rules="[rules.contactoEmergencia]"
									      label="Contacto emergencia *"
									      hint="Nombre y teléfono de una persona de confianza"
									      persistent-hint
									      required
									      rounded
									      outlined
									      hide-details="auto"
									      color="primary"
									    ></v-text-field>
										</v-col>
							  	</v-row>
							  </v-form>
			          </div>
			        </div>
			      </v-window-item>

			      <v-window-item :value="2">
			        <div class="px-4 pb-4">
			          <div class="registro-field-card pa-4 rounded-xl">
			          <v-form
							    ref="formDireccion"
							    v-model="valid2"
							    lazy-validation
							  >
							  	<v-row>
							  		<v-col cols="12" class="pb-0">
									    <v-text-field
									      v-model.trim="usuario.calle"
									      :rules="[rules.required]"
									      label="Calle *"
									      required
									      rounded
									      outlined
									      hide-details="auto"
									      color="primary"
									    ></v-text-field>
							  		</v-col>

							  		<v-col cols="6" class="pb-0">
									    <v-text-field
									      v-model.number="usuario.numero"
									      :rules="[rules.required]"
									      label="Número *"
									      required
									      rounded
									      outlined
									      hide-details="auto"
									      color="primary"
									    ></v-text-field>
										</v-col>

										<v-col cols="6" class="pb-0">
									    <v-text-field
									      v-model.trim="usuario.cp"
									      label="CP"
									      rounded
									      outlined
									      hide-details="auto"
									      color="primary"
									    ></v-text-field>
										</v-col>

										<v-col cols="12" class="pb-0">
									    <v-text-field
									      v-model.trim="usuario.colonia"
									      :rules="[rules.required]"
									      label="Colonia *"
									      required
									      rounded
									      outlined
									      hide-details="auto"
									      color="primary"
									    ></v-text-field>
							  		</v-col>

										<v-col cols="6" class="pb-0">
									    <v-text-field
									      v-model.trim="usuario.municipio"
									      :rules="[rules.required]"
									      label="Municipio *"
									      required
									      rounded
									      outlined
									      hide-details="auto"
									      color="primary"
									    ></v-text-field>
										</v-col>

										<v-col cols="6" class="pb-0">
											<v-select
									    	:items="estados"
									      v-model="usuario.estado"
									      :rules="[rules.required]"
									      label="Estado *"
									      item-text="text"
									      item-value="id"
									      rounded
									      outlined
									      hide-details="auto"
									      color="primary"
									    ></v-select>
										</v-col>
							  	</v-row>
							  </v-form>
			          </div>
			        </div>
			      </v-window-item>

			      <v-window-item :value="3">
			        <div class="px-4 pb-4">
			          <div class="registro-field-card pa-4 rounded-xl">
			          <v-form
							    ref="formEncuesta"
							    v-model="valid3"
							    lazy-validation
							  >
							  	<v-row>
							  		<v-col cols="6" class="pb-0">
									    <v-select
									    	:items="[{text:'Publicidad', id:1},{text:'Facebook', id:2},{text:'Instagram', id:3},{text:'Internet', id:4}]"
									      v-model="usuario.medio_contacto"
									      :rules="[rules.required]"
									      label="Medio de contacto"
									      required
									      rounded
									      outlined
									      hide-details="auto"
									      color="primary"
									      item-text="text"
									      item-value="id"
									    ></v-select>
							  		</v-col>

							  		<v-col cols="6" class="pb-0">
									    <v-select
									    	:items="[{text:'Estudiante', id:1},{text:'Empleado', id:2},{text:'Otro', id:3}]"
									      v-model="usuario.ocupacion"
									      :rules="[rules.required]"
									      label="Ocupación"
									      required
									      rounded
									      outlined
									      hide-details="auto"
									      color="primary"
									      item-text="text"
									      item-value="id"
									    ></v-select>
										</v-col>

										<v-col cols="6" class="pb-0">
									    <v-select
									    	:items="[{text:'Soltero', id:1},{text:'Casado', id:2},{text:'Unión libre', id:3},{text:'Otro', id:4}]"
									      v-model="usuario.estado_civil"
									      :rules="[rules.required]"
									      label="Estado civil"
									      required
									      rounded
									      outlined
									      hide-details="auto"
									      color="primary"
									      item-text="text"
									      item-value="id"
									    ></v-select>
										</v-col>

										<v-col cols="6" class="pb-0">
									    <v-select
									    	:items="[{text:'0', id:1},{text:'1', id:2},{text:'2', id:3},{text:'3 o más', id:4}]"
									      v-model="usuario.hijos"
									      :rules="[rules.required]"
									      label="Hijos"
									      required
									      rounded
									      outlined
									      hide-details="auto"
									      color="primary"
									      item-text="text"
									      item-value="id"
									    ></v-select>
										</v-col>

										<v-col cols="6" class="pb-0">
									    <v-select
									    	:items="[{text:'Hobbie', id:1},{text:'Trabajo', id:2},{text:'Escuela', id:3},{text:'Otro', id:4}]"
									      v-model="usuario.motivo_estudio"
									      :rules="[rules.required]"
									      label="Motivo de estudio"
									      required
									      rounded
									      outlined
									      hide-details="auto"
									      color="primary"
									      item-text="text"
									      item-value="id"
									    ></v-select>
										</v-col>

										<v-col cols="6" class="pb-0">
									    <v-select
									    	:items="[{text:'Carro', id:1},{text:'Metro', id:2},{text:'Camión', id:3},{text:'Otro', id:4}]"
									      v-model="usuario.transporte"
									      :rules="[rules.required]"
									      label="Transporte"
									      required
									      rounded
									      outlined
									      hide-details="auto"
									      color="primary"
									      item-text="text"
									      item-value="id"
									    ></v-select>
										</v-col>

										<v-col cols="12" class="pb-0">
									    <v-text-field
									      v-model.trim="usuario.facebook"
									      :rules="[rules.required, rules.facebook]"
									      label="Facebook *"
									      hint="Usuario o enlace de tu perfil"
									      persistent-hint
									      required
									      rounded
									      outlined
									      hide-details="auto"
									      color="primary"
									    ></v-text-field>
										</v-col>
							  	</v-row>
							  </v-form>
			          </div>
			        </div>
			      </v-window-item>

			      <v-window-item :value="4">
			        <div class="px-4 pb-6 pt-2">
			          <div class="registro-field-card registro-success-card registro-success-inner pa-6 rounded-xl text-center">
			            <div class="registro-success-icon-wrap mb-4">
			              <v-icon color="primary" size="48">mdi-email-check-outline</v-icon>
			            </div>
			            <v-img
			              class="mb-4 mx-auto"
			              contain
			              max-width="200"
			              height="120"
			              src="@/assets/alertas/send.png"
			            ></v-img>

			            <div class="registro-progress-wrap mb-4">
							      <v-progress-linear
							        v-model="value"
							        :active="show"
							        :indeterminate="query"
							        :query="true"
							        rounded
							        height="6"
							        color="primary"
							      ></v-progress-linear>
							    </div>

			            <h3 class="text-h6 font-weight-bold primary--text mb-2" v-if="correoEnviado">
			              Correo enviado con éxito
			            </h3>
			            <p class="text-body-2 registro-success-text mb-3">
			              Activa tu cuenta desde el enlace que enviamos a tu correo. Revisa también spam o promociones.
			            </p>
			            <span class="text-caption grey--text">Gracias por registrarte</span>
			          </div>
			        </div>
			      </v-window-item>
			    </v-window>

			    <v-divider v-if="step < 4" class="registro-dialog-divider"></v-divider>

			    <v-card-actions v-if="step < 4" class="registro-dialog-actions pa-4 pt-4 flex-shrink-0">
			      <v-btn
			      	v-if="step <= 3"
			        :disabled="step === 1"
			        text
			        @click="step--"
			        rounded
			        class="registro-nav-secondary text-none"
			      >
			        Regresar
			      </v-btn>
			      <v-spacer></v-spacer>

			      <v-btn
			        v-if="step < 3"
			        color="primary"
			        depressed
			        large
			        @click="avanzarPaso"
			        rounded
			        class="registro-nav-primary text-none font-weight-bold px-6"
			      >
			        Siguiente
			        <v-icon right size="20">mdi-chevron-right</v-icon>
			      </v-btn>

			      <v-btn
			        v-else-if="step == 3"
			        color="primary"
			        depressed
			        large
			        rounded
			        class="registro-nav-primary text-none font-weight-bold px-6"
			        @click="registrarDatos()"
			      >
			        Registrar
			        <v-icon right size="20">mdi-send-outline</v-icon>
			      </v-btn>
			    </v-card-actions>
          </div>
			  </v-card>
      </v-col>
	  </v-row>

		<Alerta   v-if="respuestaAlerta" :parametros="parametros"/>
		<Loader   v-if="cargar"          :loader="loader"/>

	</v-container>	
</template>
<script>
	import { mapActions, mapGetters } from 'vuex'
	// Dependencias
  const md5     = require('md5')

  // Componentes
  import Alerta     from '@/components/alertas/Alerta.vue'
  import Loader     from '@/components/alertas/Loader.vue'

  // Mixins
  import  validarErrores from '@/mixins/validarErrores.js';

  export default {
  	components:{
  		Alerta,
  		Loader
  	},

  	mixins:[validarErrores],

    data: () => ({
    	loader: true,
      cargar: false,

    	step: 1,
      ventana: 1,
      perfil: null,
      valid: true,
      valid2: true,
      valid3: true,

      usuario: {
				nombre:'',			
				apellido_paterno:'',			
				apellido_materno:'',
				edad:'',			
				email:'',			
				sexo:'',	
				contacto_emergencia:'',		
				telefono:'',			
				celular:'',

				// Direccion
				calle:'',
	    	numero:'',
	    	cp:'',
	    	colonia:'',
	    	municipio:'',
	    	estado:'',

	    	// Marketing
	    	medio_contacto:'',
		    ocupacion:'',
		    estado_civil:'',
		    hijos:'',
		    motivo_estudio:'',
		    transporte:'',
		    facebook:'',
		    activo:0,
      },

		  correoEnviado: true,

			rules: {
        required: (v) =>
          (v !== null && v !== undefined && String(v).trim() !== '') || 'Requerido.',
        email: (v) =>
          /.+@.+\..+/.test(String(v || '').trim()) || 'Ingresa un correo válido',
        sexo: (v) => (v === 0 || v === 1) || 'Selecciona una opción.',
        edad: (v) => {
          if (v === null || v === undefined || String(v).trim() === '') return 'Requerido.'
          const n = parseInt(String(v).trim(), 10)
          if (!Number.isFinite(n) || n < 10 || n > 120) {
            return 'La edad debe estar entre 10 y 120 años.'
          }
          return true
        },
        telefono: (v) => {
          if (v === null || v === undefined || v === '') return 'Requerido.'
          const d = String(v).replace(/\D/g, '')
          if (d.length < 10 || d.length > 15) {
            return 'Ingresa entre 10 y 15 dígitos (solo números).'
          }
          return true
        },
        contactoEmergencia: (v) => {
          if (v === null || v === undefined || String(v).trim() === '') return 'Requerido.'
          if (String(v).trim().length < 3) {
            return 'Escribe al menos 3 caracteres (nombre o teléfono).'
          }
          return true
        },
        facebook: (v) =>
          String(v || '').trim().length >= 2 || 'Indica tu usuario o enlace de Facebook.'
      },

      estados:[
				{id: 1, text:'Aguascalientes'},
				{id: 2, text:'Baja California'},
				{id: 3, text:'Baja California Sur'},
				{id: 4, text:'Campeche'},
				{id: 5, text:'Coahuila'},
				{id: 6, text:'Colima'},
				{id: 7, text:'Chiapas'},
				{id: 8, text:'Chihuahua'},
				{id: 9, text:'Distrito Federal'},
				{id: 10, text:'Durango'},
				{id: 11, text:'Guanajuato'},
				{id: 12, text:'Guerrero'},
				{id: 13, text:'Hidalgo'},
				{id: 14, text:'Jalisco'},
				{id: 15, text:'México'},
				{id: 16, text:'Michoacán'},
				{id: 17, text:'Morelos'},
				{id: 18, text:'Nayarit'},
				{id: 19, text:'Nuevo León'},
				{id: 20, text:'Oaxaca'},
				{id: 21, text:'Puebla'},
				{id: 22, text:'Querétaro'},
				{id: 23, text:'Quintana Roo'},
				{id: 24, text:'San Luis Potosí'},
				{id: 25, text:'Sinaloa'},
				{id: 26, text:'Sonora'},
				{id: 27, text:'Tabasco'},
				{id: 28, text:'Tamaulipas'},
				{id: 29, text:'Tlaxcala'},
				{id: 30, text:'Veracruz'},
				{id: 31, text:'Yucatán'},
				{id: 32, text:'Zacatecas'},
      ],

      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

     	respuestaAlerta:false,

     	value: 0,
      query: false,
      show: true,
      interval: 0,

    }),

    computed:{
    	...mapGetters( 'login', [ 'getUsuarioLMS', 'getDatosUsuarioLMS']),

    	currentTitle () {
        switch (this.step) {
          case 1: return 'Datos personales'
          case 2: return 'Dirección'
          case 3: return 'Encuesta'
          default: return 'Registrar cuenta'
        }
      },

      totalPasosRegistro () {
        return 3
      },

      iconoPaso () {
        switch (this.step) {
          case 1: return 'mdi-account-circle-outline'
          case 2: return 'mdi-map-marker-outline'
          case 3: return 'mdi-clipboard-text-outline'
          default: return 'mdi-check-decagram-outline'
        }
      },

      textoIntroPaso () {
        switch (this.step) {
          case 1:
            return 'Usa tu nombre legal tal como aparece en identificaciones. Los campos con asterisco son obligatorios antes de continuar.'
          case 2:
            return 'Indica el domicilio donde podemos localizarte para trámites o constancias cuando apliquen.'
          case 3:
            return 'Unas preguntas breves para conocerte mejor. Tus respuestas son confidenciales y nos ayudan a mejorar el servicio.'
          default:
            return ''
        }
      },

      seccionTitulo () {
        switch (this.step) {
          case 1: return '1. Identidad y contacto'
          case 2: return '2. Ubicación'
          case 3: return '3. Perfil y hábitos'
          default: return ''
        }
      },

      seccionSubtitulo () {
        switch (this.step) {
          case 1:
            return 'Nombre, correo, edad, sexo y datos de contacto de emergencia.'
          case 2:
            return 'Calle, número, código postal, colonia, municipio y estado.'
          case 3:
            return 'Medio por el que nos conociste, ocupación, estado civil y movilidad.'
          default: return ''
        }
      },

    },

    created(){
    	this.usuario.nombre = this.getUsuarioLMS.nombre
			this.usuario.apellido_paterno = this.getUsuarioLMS.apellido_paterno
			this.usuario.apellido_materno = this.getUsuarioLMS.apellido_materno
			this.usuario.email = this.getUsuarioLMS.email
			this.usuario.telefono = this.getUsuarioLMS.telefono
			this.usuario.celular = this.getUsuarioLMS.telefono
    },

    methods: {
    	...mapActions( 'login', [ 'grabarUsuario', 'salirLogin' ]),

      mostrarErrorValidacion (mensaje) {
        this.parametros.mensaje = mensaje
        this.parametros.dialogError = true
        this.parametros.color = '#FF2C2C'
        this.respuestaAlerta = true
      },

      avanzarPaso () {
        const refPorPaso = { 1: 'form', 2: 'formDireccion' }
        const nombreRef = refPorPaso[this.step]
        const formRef = nombreRef ? this.$refs[nombreRef] : null
        if (formRef && !formRef.validate()) {
          this.mostrarErrorValidacion('Revisa los campos marcados antes de continuar.')
          return
        }
        this.step++
      },

      validarDatos () {
        const refs = ['form', 'formDireccion', 'formEncuesta']
        return refs.every((r) => !this.$refs[r] || this.$refs[r].validate())
      },

      registrarDatos (){
      	if( this.validarDatos() ){
      		this.cargar = true
      		this.usuario['id_usuario'] = this.getUsuarioLMS.id
	      	this.$http.post('usuario.enviar.correo', this.usuario).then( response => {
	      		this.step++
	      		this.cargar = false
	      		this.iniciarContador()
	      	}).catch( error => {
	      		this.cargar = false
	      		if( error.status == 400 || error.status == 500 ){
	      			this.parametros.mensaje      = error.body.message
	      			this.parametros.dialogError  = true 
	      			this.parametros.color        = '#FF2C2C'
	      			this.respuestaAlerta         = true 
	      		}
	      	})
      	}else{
      		this.mostrarErrorValidacion('Por favor, revisa que todos tus datos estén correctos.')
      	}
      },

      iniciarContador ( ){
      	this.query = true
        this.show = true
        this.value = 0

        setTimeout(() => {
          this.query = false

          this.interval = setInterval(() => {
            if (this.value === 100) {
              clearInterval(this.interval)
              this.salirLogin()

              return setTimeout(this.queryAndIndeterminate, 2000)
            }
            this.value += 5
          }, 1000)
        }, 500)
      } 
    },
  }
</script>
<style scoped>
  .registro-page {
    background: linear-gradient(180deg, #f5f7fb 0%, #eef2f8 50%, #f8fafc 100%);
    min-height: 100%;
  }

  .registro-teaser-card {
    border: 1px solid rgba(25, 118, 210, 0.12) !important;
    background: linear-gradient(145deg, #fbfdff 0%, #f0f6ff 42%, #ffffff 100%) !important;
    box-shadow:
      0 4px 6px -1px rgba(25, 118, 210, 0.06),
      0 12px 40px -8px rgba(25, 118, 210, 0.12) !important;
  }

  .registro-teaser-inner {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    padding: 20px 20px 18px;
  }

  .registro-teaser-icon-wrap {
    flex-shrink: 0;
    width: 56px;
    height: 56px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(25, 118, 210, 0.1);
    border: 1px solid rgba(25, 118, 210, 0.15);
  }

  .registro-teaser-copy {
    flex: 1;
    min-width: 0;
    text-align: left;
  }

  .registro-teaser-overline {
    display: block;
    color: rgba(0, 0, 0, 0.45) !important;
    font-weight: 600;
    margin-bottom: 4px;
  }

  .registro-teaser-desc {
    color: rgba(0, 0, 0, 0.58);
    line-height: 1.45;
  }

  .letter-spacing-1 {
    letter-spacing: 0.08em !important;
  }

  .registro-wizard-card {
    background: linear-gradient(160deg, #fbfdff 0%, #f0f6ff 38%, #ffffff 100%) !important;
    box-shadow:
      0 4px 6px -1px rgba(25, 118, 210, 0.06),
      0 12px 40px -8px rgba(25, 118, 210, 0.1) !important;
    border: 1px solid rgba(25, 118, 210, 0.08) !important;
  }

  .registro-card-body {
    max-width: 560px;
    margin-left: auto;
    margin-right: auto;
  }

  .registro-title-wrap {
    min-width: 0;
  }

  .registro-main-title {
    letter-spacing: -0.02em;
    line-height: 1.25;
  }

  .registro-step-pill {
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    padding: 6px 14px;
    border-radius: 999px;
    background: rgba(25, 118, 210, 0.1);
    color: #1565c0;
    border: 1px solid rgba(25, 118, 210, 0.2);
  }

  .registro-intro-alert {
    border-radius: 12px !important;
    background: rgba(25, 118, 210, 0.06) !important;
    border-left-width: 4px !important;
  }

  .registro-seccion-header {
    padding-bottom: 2px;
    border-bottom: 1px solid rgba(25, 118, 210, 0.12);
  }

  .registro-titulo-seccion {
    font-size: 1.05rem;
    font-weight: 800;
    letter-spacing: 0.02em;
  }

  .registro-subtitulo-seccion {
    font-size: 0.875rem;
    color: rgba(0, 0, 0, 0.6);
    line-height: 1.35;
  }

  .registro-field-card {
    background: #ffffff;
    border: 1px solid rgba(25, 118, 210, 0.1);
    box-shadow:
      0 2px 4px rgba(25, 118, 210, 0.04),
      0 8px 24px rgba(0, 0, 0, 0.04);
  }

  .registro-success-card {
    background: linear-gradient(180deg, #ffffff 0%, #fafcfe 100%);
  }

  .registro-success-inner {
    max-width: 420px;
    margin-left: auto;
    margin-right: auto;
  }

  .registro-success-icon-wrap {
    display: inline-flex;
    padding: 12px;
    border-radius: 50%;
    background: rgba(25, 118, 210, 0.08);
  }

  .registro-success-text {
    color: rgba(0, 0, 0, 0.65);
    line-height: 1.45;
    max-width: 360px;
    margin-left: auto;
    margin-right: auto;
  }

  .registro-progress-wrap {
    max-width: 280px;
    margin-left: auto;
    margin-right: auto;
  }

  .registro-dialog-divider {
    border-color: rgba(25, 118, 210, 0.08) !important;
  }

  .registro-dialog-actions {
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
    border-top: 1px solid rgba(0, 0, 0, 0.06) !important;
    align-items: center !important;
  }

  .registro-nav-secondary.v-btn {
    font-weight: 600;
    letter-spacing: 0.04em;
    color: rgba(0, 0, 0, 0.62) !important;
  }

  .registro-nav-primary.v-btn {
    min-height: 48px !important;
    box-shadow: 0 4px 12px rgba(25, 118, 210, 0.28) !important;
  }
</style>